import React, { useContext, useMemo } from 'react';

import { useLocation } from '@reach/router';

import { ReactComponent as WarningRoundIcon } from '../../assets/images/icons/WarningRound.svg';
import { PageContext } from '../../context/PageContext';
import { pathToPreviousVersion } from '../../utils';
import { InternalLink } from '../InternalLink';

import * as classes from './style.module.scss';

export const Outdated: React.FC = () => {
  const { pathname } = useLocation();
  const {
    slug,
    version,
    defaultVersion,
    versions,
    sidebarContents,
    name,
    platform,
    allSlugs,
    platforms,
  } = useContext(PageContext);

  if (version === 'docs' || (version === defaultVersion && sidebarContents)) {
    return null;
  }

  const prev = useMemo(() => {
    if (versions) {
      const versionIndex = versions.findIndex(({ id }) => id === version);
      const defaultIndex = versions.findIndex(
        ({ id }) => id === defaultVersion,
      );
      return versionIndex < defaultIndex;
    }
    return true;
  }, [version, defaultVersion, versions]);

  const path = pathToPreviousVersion(
    defaultVersion,
    name,
    pathname,
    platform,
    version,
    slug,
    defaultVersion,
    allSlugs,
    platforms,
  );

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <WarningRoundIcon className={classes.icon} />
        <div>
          <span className={classes.text}>
            You&apos;re viewing documentation for a{' '}
            {prev ? 'previous' : 'future'} version of this software.
          </span>
          <InternalLink className={classes.link} to={path}>
            Switch to the latest stable version
          </InternalLink>
        </div>
      </div>
    </div>
  );
};
